// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-education[data-v-a2abc5e4] {\n  margin-top: 25px;\n}\n.item[data-v-a2abc5e4]:not(:first-child) {\n  margin-top: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
